<template>
  <div id="app">
    <!-- 非微信浏览器提示页面 -->
    <div v-if="!isWechat" class="wechat-only-page">
      <div class="wechat-only-content">
        <van-icon name="wechat" size="80" color="#07c160" />
        <h2>请在微信中打开</h2>
        <p>本应用仅支持在微信浏览器中使用</p>
        <div class="qr-hint">
          <van-icon name="scan" size="20" />
          <span>请使用微信扫一扫打开此页面</span>
        </div>
      </div>
    </div>
    
    <!-- 微信浏览器正常显示 -->
    <router-view v-else />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'App',
  setup() {
    const isWechat = ref(true);
    
    onMounted(() => {
      // 检测是否在微信浏览器中
      isWechat.value = /MicroMessenger/i.test(navigator.userAgent);
      
      if (!isWechat.value) {
        console.log('⚠️ 非微信浏览器，禁止访问');
      }
    });
    
    return {
      isWechat
    };
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  background-color: #f5f5f5;
}

/* 非微信浏览器提示页面样式 */
.wechat-only-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.wechat-only-content {
  background: white;
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 100%;
}

.wechat-only-content .van-icon {
  margin-bottom: 24px;
  animation: bounce 2s infinite;
}

.wechat-only-content h2 {
  font-size: 24px;
  color: #303133;
  margin-bottom: 12px;
  font-weight: 600;
}

.wechat-only-content p {
  font-size: 16px;
  color: #606266;
  margin-bottom: 32px;
  line-height: 1.6;
}

.qr-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 12px;
  color: #909399;
  font-size: 14px;
}

.qr-hint .van-icon {
  margin-right: 8px;
  animation: none;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
}
</style>
